import api from './api';

export const zestpKpiAPI = {
  getKpiDashboard: (params?: { academic_year?: string; refresh?: string }) =>
    api.get('/sis-integration/zestp-kpis/', { params }),
};
